import set from 'lodash/set';

const initialState = () => ({
  id: null,
  name: '',
  email: '',
  rfc: '',
  curp: '',
  socialSecurityNumber: '',
  jobRelationshipStart: '',
  seniority: '',
  contractType: '',
  unionized: '',
  workingDayType: '',
  regimeType: '',
  employedNumber: '',
  department: '',
  position: '',
  hazardPosition: '',
  paymentPeriodicity: '',
  bank: '',
  bankAccount: '',
  baseSalary: '',
  dailyBaseSalary: '',
  zipCode: '',
  localityKey: '',
  count: 0,
  page: 1,
  size: 20,
  csv: null,
  csvFileName: '',
  list: [],
  loading: false,
});

export default {
  setValue(state, { accessor, value }) {
    set(state, accessor, value);
  },
  setValues(state, payload) {
    Object.keys(payload).forEach((key) => {
      set(state, key, payload[key]);
    });
  },
  setInitialState(state) {
    const newState = initialState();
    Object.keys(newState).forEach((key) => {
      set(state, key, newState);
    });
  },
};
